import { Component } from '@angular/core';
import { BbInfoComponent } from '../bb-info/bb-info.component';

@Component({
	selector: 'bb-warning',
	templateUrl: './bb-warning.component.html',
	styleUrls: ['./bb-warning.component.scss']
})

export class BbWarningComponent extends BbInfoComponent {

}
